export default __webpack_public_path__ + "assets/media/13-1-4140186.jpg";